import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  template: require("./template.html")
})
class PhonesComponent extends Vue {
  @Prop()
  phones: string;

  get NextPhones() {
    if (this.phones) {
      let result = this.phones.split(",");

      result.shift(); // remove first phone

      return result;
    }

    return [];
  }

  get FirstPhone() {
    if (this.phones) {
      return this.phones.split(",")[0];
    }

    return "";
  }
}

export default PhonesComponent;
